<template>
    <div class="newPage">
        <div class="content">

            <div class="HistoryList">
                <el-table
                        :data="historyList.list"
                        stripe
                >
                    <el-table-column
                            label="序号"
                            align="center"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            align="center"
                            label="模板名称"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="createTime" align="center"
                            label="时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.createTime | YearDate}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createUserName" align="center"
                            label="操作者">
                    </el-table-column>
                    <el-table-column
                            width="540"
                            prop="address" align="center"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="jump(scope.row)">修改</el-button>
                            <el-button size="mini" @click="jumpNow(scope.row)">实时生成</el-button>
                            <el-button size="mini" @click="jumpInt(scope.row)">定时生成</el-button>
                            <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
                            <el-button size="mini" @click="download(scope.row,1)">下载 word</el-button>
                            <el-button size="mini" @click="download(scope.row,2)">下载 pdf</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination
                        v-show="historyList.totalCount>0"
                        :total="historyList.totalCount"
                        :page.sync="params.page"
                        :limit.sync="params.pageSize"
                        @pagination="getWordTemplategenerateList"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"
    import {report} from "../mixin";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "templateAdmin",
        components: {},
        mixins: [report],
        data() {
            return {
                historyList: {
                    currPage: 1,
                    list: [],
                    pageSize: 0,
                    totalCount: 0,
                    totalPage: 0,
                },
                params: {
                    page: 1,
                    pageSize: 10,
                    type: 3
                }
            }
        },
        created() {
            this.getWordTemplategenerateList()
        },
        methods: {
            getWordTemplategenerateList() {
                let data = this.params
                this.$http.get(url.wordTemplategenerateList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // this.historyList.list.length > 0 ? this.historyList.list = this.historyList.list.concat(res.data.data.list) : this.historyList = res.data.data
                        this.historyList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            jump(item) {
                console.log(item)
                if (item.type === 3) {
                    let queryData = {
                        para: item.para,
                        id: item.id
                    }
                    this.$router.push({name: 'VOCreportModify', query: queryData})
                    let data = {
                        routerName: 'VOCreportModify',
                        query: JSON.stringify(queryData),
                        name: '修改模板'
                    }
                    this.handleVOCTagsList(data)
                }
            },
            jumpNow(item) {
                if (item.type === 3) {
                    this.$router.push({name: 'VOCrealTime', query: {para: item.para, paraId: item.id}})
                }
            },
            jumpInt(item) {
                if (item.type === 3) {
                    this.$router.push({name: 'VOCfixedTime', query: {para: item.para, paraId: item.id}})
                }
            },
            load() {
                console.log('chudi')
                if (this.historyList.totalPage > this.params.page) {
                    this.params.page++
                    this.getWordTemplategenerateList()
                }
            },
            deleteItem(item, index) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let data = {
                        id: item.id
                    }

                    this.$http.post(url.wordTemplatedelete, data).then(res => {
                        if (res.data.code === '200') {
                            this.getWordTemplategenerateList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                });
            },

            download(item, type) {
                let data = {
                    id: item.id,
                    type: type,
                    token: localStorage.getItem('token')
                }
                let allUrl = url.wordTemplatedownload + params(data)
                window.open(allUrl, '_blank')
            }
        }
    }
</script>

<style scoped lang="less">

    .HistoryList {

        width: 80%;
        min-width: 550px;
        margin: 0 auto;
        padding: 10px;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        background-color: #fff;
        .HistoryItem {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .histyTimer {

            }
            .histyIcon {
                background-color: #1b486f;
                border-radius: 50%;
                margin: 0 20px;

                img {
                    width: 20px;
                    height: 20px;
                }

            }
            .histyName {

                flex: 1;
            }
            .histyOther {

            }
        }
        :last-child {
            margin-bottom: 0;
        }
    }
</style>